// src/context/ModalContext.js
import React, { createContext, useState, useCallback } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

export const ModalContext = createContext();

export function ModalProvider({ children }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({
    title: '',
    message: '',
    onConfirm: null,  // optional callback
    onClose: null,    // optional callback
  });

  // Show a simple info modal
  const openInfoModal = useCallback(({ title, message, onClose }) => {
    setModalContent({ title, message, onClose });
    setModalOpen(true);
  }, []);

  // Show a confirmation modal
  const openConfirmModal = useCallback(({ title, message, onConfirm, onClose }) => {
    setModalContent({ title, message, onConfirm, onClose });
    setModalOpen(true);
  }, []);

  const handleClose = () => {
    setModalOpen(false);
    if (modalContent.onClose) modalContent.onClose();
  };

  const handleConfirm = () => {
    setModalOpen(false);
    if (modalContent.onConfirm) modalContent.onConfirm();
  };

  return (
    <ModalContext.Provider value={{ openInfoModal, openConfirmModal }}>
      {children}

      {/* The actual MUI Dialog that displays when modalOpen is true */}
      <Dialog open={modalOpen} onClose={handleClose}>
        <DialogTitle>{modalContent.title}</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body1">{modalContent.message}</Typography>
        </DialogContent>
        <DialogActions>
          {modalContent.onConfirm ? (
            <>
              <Button onClick={handleClose}>Cancel</Button>
              <Button onClick={handleConfirm} variant="contained" color="primary">
                Confirm
              </Button>
            </>
          ) : (
            <Button onClick={handleClose}>OK</Button>
          )}
        </DialogActions>
      </Dialog>
    </ModalContext.Provider>
  );
}
